export default __webpack_public_path__ + "static/media/ts-poster-small-mobile.5129a87e.jpg";